module.exports = __webpack_public_path__ + "img/item-image-placeholder.988b67b3.svg";